import React, { useEffect, useState } from "react";
import CheckBoxInput from "@components/input/CheckBoxInput";
import { BrandDropdownInput } from "@pages/register/_components/index";
import styled from "@emotion/styled";

import { useFormContext } from "react-hook-form";
import { useQuery } from "@tanstack/react-query";
import { useApiRequest } from "@utils/ApiRequest";
import { useTranslation } from "react-i18next";

const Container = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  zIndex: "1003",
  ".label": {
    fontSize: "1.6rem",
    lineHeight: "1.6rem",
    fontWeight: theme.fontWeight.medium,
  },

  ".desc": {
    fontSize: "1.2rem",
    lineHeight: "1.2rem",
    color: theme.color.gray,
  },
}));

const InputContainer = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
});

const NoBrandBox = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "0.6rem",

  ".error": {
    color: theme.color.orange,
    fontSize: "1.2rem",
    lineHeight: "1.2rem",
  },
}));

const ErrorMessage = styled.div(({ theme }) => ({
  color: theme.color.orange,
  fontSize: "1.2rem",
  lineHeight: "1.8rem",
}));

const BrandCheckList = () => {
  const {
    setValue,
    watch,
    trigger,
    formState: { errors },
  } = useFormContext();

  const { t } = useTranslation();
  const { getBrandList } = useApiRequest();
  const brandId = watch("brand_id");

  useEffect(() => {
    if (brandId) {
      trigger("brand_id");
    }
  }, [brandId, trigger]);

  // 브랜드 ID에 따라 초기 selectedKey 설정
  const [selectedKey, setSelectedKey] = useState(() => {
    if (!brandId) return null;
    if (brandId === 1) return 1; // 브랜드 없음
    if (brandId === 2) return 2; // 노라벨
    return 0; // 그 외의 경우는 브랜드 있음
  });

  const { data: brandList } = useQuery({
    queryKey: ["brandList"],
    queryFn: getBrandList,
  });

  const handleInputClick = (key: number) => {
    setSelectedKey(key);
    setValue("brand_id", key);
  };

  return (
    <Container>
      <span className="label">{t("브랜드")}</span>
      <span className="desc">
        {t("아래 세가지 옵션 중 하나를 선택해주세요.")}
      </span>

      <InputContainer>
        {/* <CheckBoxInput
          label="브랜드 있음"
          checked={selectedKey === 0}
          onClick={() => handleInputClick(0)}
        /> */}

        {/* {selectedKey === 0 && (
          <BrandDropdownInput options={brandList} name="brand_id" />
        )} */}

        <BrandDropdownInput
          options={brandList}
          name="brand_id"
          setSelectedKey={setSelectedKey}
        />

        <NoBrandBox>
          <CheckBoxInput
            label="찾는 브랜드 없음"
            checked={selectedKey === 1}
            onClick={() => handleInputClick(1)}
          />
          {selectedKey === 1 && (
            <span className="error">
              {t("찾는 브랜드가 없는 경우 브랜드명을 상품명에 적어주세요")}
            </span>
          )}
        </NoBrandBox>
        <CheckBoxInput
          label="노라벨 (라벨이 없는 상품)"
          checked={selectedKey === 2}
          onClick={() => handleInputClick(2)}
        />
        {errors?.brand_id && (
          <ErrorMessage>{errors?.brand_id?.message?.toString()}</ErrorMessage>
        )}
      </InputContainer>
    </Container>
  );
};

export default BrandCheckList;
